import React, { useState } from "react";
import "../styles/GalleryGrid.css";

const GalleryGrid = ({ galleries }) => {
    const [selectedPost, setSelectedPost] = useState(null);
    const [selectedGallery, setSelectedGallery] = useState(galleries[0]?.id || null);

    const openLightbox = (post) => {
        setSelectedPost(post);
    };

    const closeLightbox = () => {
        setSelectedPost(null);
    };

    const currentGallery = galleries.find((g) => g.id === selectedGallery);

    return (
        <div className="gallery-container">
            <div className="gallery-header">
                <h2 className="gallery-main-title">My <span className="title-italic">Projects</span></h2>
                <p className="gallery-subtitle">Documenting Adventures Across the Globe</p>
            </div>

            {/* Gallery Tabs */}
            <div className="gallery-tabs">
                {galleries.map((gallery) => (
                    <button
                        key={gallery.id}
                        className={`gallery-tab ${selectedGallery === gallery.id ? "active" : ""
                            }`}
                        onClick={() => setSelectedGallery(gallery.id)}
                    >
                        {gallery.name}
                    </button>
                ))}
            </div>

            {/* Gallery Grid - 2x3 Bold Layout */}
            <div className="gallery-grid-bold">
                {currentGallery?.posts.map((post, index) => (
                    <div
                        key={post.id}
                        className="gallery-item-bold"
                        onClick={() => openLightbox(post)}
                    >
                        <img src={post.image} alt={post.caption} />
                        <div className="gallery-bold-overlay">
                            <div className="gallery-bold-content">
                                <h3 className="gallery-bold-title">{post.title || post.caption}</h3>
                                {post.subtitle && <p className="gallery-bold-subtitle">{post.subtitle}</p>}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Lightbox */}
            {selectedPost && (
                <div className="lightbox" onClick={closeLightbox}>
                    <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                        <button className="lightbox-close" onClick={closeLightbox}>
                            ×
                        </button>
                        <img src={selectedPost.image} alt={selectedPost.caption} />
                        <div className="lightbox-caption">
                            <p>{selectedPost.caption}</p>
                            <span className="lightbox-date">{new Date(selectedPost.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default GalleryGrid;
